<template>
  <div class='box'>
    <div class='wave one'></div>
    <div class='wave two'></div>
    <div class='wave three'></div>
    <div class='wave four'></div>
    <div class='wave five'></div>
  </div>
</template>
